import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'arrayLength',
  standalone: true,
})
export class ArrayLengthPipe implements PipeTransform {
  transform<T>(array: T[], length: number): T[] {
    array.length = length;
    return array;
  }
}
